import {getFormMessages, isRegistrationClosedVisible, isTicketed} from '@wix/wix-events-commons-statics'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {FormStep} from '../../constants'
import {useAppActions, useAppSelector} from '../../hooks/runtime'
import {getEvent} from '../../selectors/event'
import {isMemberEventRsvpReady, isMemberRsvpExists} from '../../selectors/member-rsvp'
import {shouldNavigateToForm as shouldNavigateToFormSelector} from '../../selectors/rsvp'
import c from '../classnames.scss'
import {FormButton} from '../form-button/form-button'
import {FormSteps} from '../form-steps'
import {Step} from '../form-steps/interfaces'
import {RegistrationLayout} from '../registration-layout'
import {Summary} from '../summary'
import {RsvpFormContainer} from './container'
import s from './rsvp-form.scss'

export const RsvpForm = () => {
  const {t} = useTranslation()
  const {formPageLoaded, navigateToMainPage, scrollToElement} = useAppActions()

  const event = useAppSelector(getEvent)
  const memberRsvpExists = useAppSelector(isMemberRsvpExists)
  const memberRsvpReady = useAppSelector(isMemberEventRsvpReady)
  const shouldNavigateToForm = useAppSelector(shouldNavigateToFormSelector)

  const {
    registrationClosed: {message, exploreEventsActionLabel},
  } = getFormMessages(event)

  React.useEffect(() => {
    formPageLoaded(false)
  }, [])

  if (!memberRsvpReady || (memberRsvpExists && !isTicketed(event) && !shouldNavigateToForm)) {
    return null
  }

  const containerClass = classNames(c.formBackgroundColor)

  if (isRegistrationClosedVisible(event)) {
    return (
      <div className={classNames(containerClass, s.closedRegistrationMessageContainer)}>
        <div className={classNames(s.closedRegistrationMessage, c.formTitleFont, c.formTitleColor)}>{message}</div>
        <FormButton text={exploreEventsActionLabel} width="auto" onClick={() => navigateToMainPage()} />
      </div>
    )
  }

  return (
    <RsvpFormContainer>
      {(steps: Step[], currentStep: FormStep) => (
        <div data-hook={DH.RSVP_FORM} className={containerClass}>
          <RegistrationLayout
            Right={<Summary />}
            Left={<FormSteps currentStep={currentStep} steps={steps} t={t} scrollToElement={scrollToElement} />}
          />
        </div>
      )}
    </RsvpFormContainer>
  )
}
